/**
 * Adres metninde tekrar ayıklama — saf yardımcı (I/O, i18n, format yok).
 *
 * Abant siparişinde `order.address` ile `order.addressNote` AYNI adresi taşıyor:
 * sipariş detayında adres iki kez, "Panel bilgisi" kutusunda bir kez daha basılıyor.
 * Bazı paneller `addressNote` alanına gerçek bir bilgi koyuyor ("Apartman girişi sol
 * taraf"), bazıları adresin kendisini; ikincisi gürültü.
 *
 * Karşılaştırma ham metinle yapılmaz — paneller aynı adresi farklı yazar:
 * "X Mah. Y sok. No:14/13 MERKEZ / BOLU" ↔ "X mahallesi y sok no 14 13 merkez bolu".
 * Bu yüzden iki taraf da aynı normalizasyondan geçirilir:
 *
 *   1. NFC — birleşik karakterler (örn. "İ" + birleşen nokta) ayrışmış hâline gelir.
 *   2. `toLocaleUpperCase('tr-TR')` — Türkçe eşleme: `i`→`İ`, `ı`→`I`. ASCII
 *      büyütmede "inonu" ile "İnönü" eşleşmezdi.
 *   3. Noktalama ve TÜM boşluklar atılır — "No:14/13" ile "No 14 13" eşleşsin.
 *
 * Kural: normalleşmiş not, normalleşmiş adresin İÇİNDE geçiyorsa ya da adres notun
 * içinde geçiyorsa not TEKRARDIR. Aksi halde gerçek bilgidir ve korunur.
 */

/** Harf ve rakam dışındaki her şey (noktalama + boşluk) tek seferde silinir. */
const NON_ALPHANUMERIC = /[^\p{L}\p{N}]+/gu;

/** Karşılaştırma için normalleştirilmiş adres metni. Boş/null → `''`. */
export function normalizeAddressText(value: string | null | undefined): string {
  if (!value) return '';
  return value.normalize('NFC').toLocaleUpperCase('tr-TR').replace(NON_ALPHANUMERIC, '');
}

/**
 * `note`, `address`'i TEKRAR MI ediyor?
 *
 * - Not boş/null → `true` (gösterilecek bir şey yok).
 * - Adres boş/null → `false`: not elde TEK adres bilgisi, bastırılırsa adres kaybolur.
 * - Not adresin içinde geçiyorsa veya adres notun içinde geçiyorsa → `true`.
 */
export function isRedundantAddressNote(
  note: string | null | undefined,
  address: string | null | undefined,
): boolean {
  const normalizedNote = normalizeAddressText(note);
  if (normalizedNote === '') return true;

  const normalizedAddress = normalizeAddressText(address);
  if (normalizedAddress === '') return false;

  return normalizedAddress.includes(normalizedNote) || normalizedNote.includes(normalizedAddress);
}
